import { cloneDeep } from 'lodash';
const SET_SORT_PRODUCTS = 'SET_SORT_PRODUCTS';
const SET_SORT_TYPE = 'SET_SORT_TYPE';
const SET_SORT_INITIAL_ORDER = 'SET_SORT_INITIAL_ORDER';
const SET_SORT_ORDER = 'SET_SORT_ORDER';

const initialSortResults = {
    products            : [],
    initialOrder         : [],
    order               : "ascending",
    type                : "recommended"
}

export default function reducer(state = cloneDeep(initialSortResults), action) {
    switch (action.type) {
        case SET_SORT_ORDER:
            return { ...state, order: action.payload};
        case SET_SORT_TYPE:
            return { ...state, type: action.payload};
        case SET_SORT_PRODUCTS:
            return { ...state, products: [...action.payload]};
         case SET_SORT_INITIAL_ORDER:
            return { ...state, initialOrder: [...action.payload]};
        default:
            return state;
    }
}

export function setSortProducts(products){
    return {
        type: SET_SORT_PRODUCTS,
        payload: products
    };
}


export function initializeSort(){
    return (dispatch, getState) => {
        let initalSort = getState().activeFilterResult && getState().activeFilterResult.products ? getState().activeFilterResult.products : [];
        return dispatch([
            setSortOrder("ascending"),
            setSortType("recommended"),
            setSortInitialOrder(initalSort),
            setSortProducts(initalSort)
        ]);
    }
}

export function setSortInitialOrder(products){
    return {
        type: SET_SORT_INITIAL_ORDER,
        payload: products
    };
}

export function setSortOrder(order){
    return {
        type: SET_SORT_ORDER,
        payload: order
    }
}

export function setSortType(type){
    return {
        type: SET_SORT_TYPE,
        payload: type
    }
}

export function getSortedProducts(){
    return (dispatch, getState) => {
        let activeProducts = getState().activeFilterResult && getState().activeFilterResult.products ?
            getState().activeFilterResult.products : [];
        if( activeProducts.length <= 0 ) return dispatch(setSortProducts([]));
        switch(getState().sort.type){
          case "author":
            var sortedAuthors =  activeProducts.map(a=>{
              if(a.authors && a.authors.length){
                let authorSplit = a.authors[0].name.split(' ');
                return authorSplit[authorSplit.length - 1];
              }
            }).sort();
            sortedAuthors = getState().sort.order === "descending" ? sortedAuthors.reverse() : sortedAuthors;
            return dispatch(setSortProducts(activeProducts.sort((a,b)=>{
              if(a.authors && b.authors && a.authors.length && b.authors.length){
                a = a.authors[0].name.split(' ');
                b = b.authors[0].name.split(' ');
                return sortedAuthors.indexOf(a[a.length-1]) - sortedAuthors.indexOf(b[b.length-1]);
              }
              return 0;
            })));
            break;
          case "title":
            var sortedTitles = getState().sort.order === "descending" ? activeProducts.map(a=>a.title).sort().reverse() :
                activeProducts.map(a=>a.fields ? a.fields.title : a.title).sort();
            return dispatch(setSortProducts(activeProducts.sort((a,b)=>sortedTitles.indexOf(a.title) - sortedTitles.indexOf(b.title))));
            break;
          case "release-date":
            return dispatch(setSortProducts(activeProducts.sort((a,b)=>{
              var aDate = new Date(a.available_date);
              var bDate = new Date(b.available_date);
              if(getState().sort.order === "descending") return aDate - bDate
              return bDate - aDate
            })));
            break;
          case "recommended":
          case "":
            let sortedIds = getState().sort.order === "descending" ? getState().sort.initialOrder.slice(0).reverse() : getState().sort.initialOrder;
            return dispatch(setSortProducts(sortedIds));
            break;
        }
    }
  }


// WEBPACK FOOTER //
// ./src/modules/sort.js